import { isFrench } from "./helpers.js";

/** Handles the breadcrumbs on the Ninja Forms multi-page forms. */
export function initializeNFBreadcrumbs(): void {
	//Bail if no form is present on the page. (Determined by the presence of the loading spinner)
	if (!document.querySelector(".nf-loading-spinner")) return;
	const observerOptions = {
		childList: true,
		subtree: true,
	};
	const elementToWatch = document.querySelector(".nf-form-wrap, .nf-form-cont");
	if (!elementToWatch) {
		return;
	}

	const observer = new MutationObserver(() => {
		update();
	});
	observer.observe(elementToWatch, observerOptions);
}

/**
 * Add event listeners to the previous and next buttons as well as the other
 * breadcrumbs.
 */
function addListeners() {
	const addButtonListener = (selector: string, frText: string) => {
		const button = document.querySelector<HTMLInputElement>(selector);
		if (button) {
			if (isFrench() && button.value !== frText) {
				button.value = frText;
			}
			button.addEventListener("click", () =>
				setTimeout(() => {
					update();
				}, 0),
			);
		}
	};

	addButtonListener(".nf-next", "Suivant");
	addButtonListener(".nf-previous", "Précédent");

	findItems().forEach((breadCrumb) => {
		breadCrumb.addEventListener("click", () =>
			setTimeout(() => {
				update();
			}, 0),
		);
	});
}

/**
 * Finds the breadcrumbs and assigns them to the items field.
 *
 * @returns The breadcrumb items.
 */
function findItems() {
	return Array.from(document.querySelectorAll(".nf-breadcrumb")).map(
		(element) => element.parentNode as HTMLElement,
	);
}

/** Add completed and active classes to allow for styling of those items. */
function setCompletedItems() {
	/** Tracks whether we are before or after the active item in the list. */
	let activePassed = false;
	findItems().forEach((element) => {
		element.classList.remove("completed");
		if (activePassed) return;
		if (element.classList.contains("active")) {
			activePassed = true;
			return;
		}
		element.classList.add("completed");
	});
}

/** Handles the change of active page. */
function update() {
	addListeners();
	setCompletedItems();
}
